import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-eye',
  templateUrl: './icon-eye.component.html',
  styleUrls: ['./icon-eye.component.scss'],
})
export class IconEyeComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
